.date__container {
  align-items: center;
  display: flex;
  height: 50px;
  justify-content: center;
  width: 50px;
  background: none;
  border: none;
}

.date__container :hover {
  cursor: pointer;
}

.date__inner--default {
  color: var(--brand-color);
  font-family: var(--dateIcn-font);
  font-size: var(--dateIcn-font-size);
}

@media screen and (max-width: var(--mobileWith)) {
  .date__inner--default {
    --dateIcn-Font: "SF-Pro-Text-Semibold";
  }
}

.date__inner--selected {
  align-items: center;
  animation: fadeInBgColor 0.5s forwards;
  border-radius: 50%;
  color: white;
  display: flex;
  height: 2em;
  justify-content: center;
  width: 2em;
}

.date__inner--invalid {
  color: #cccccc;
}

@keyframes fadeInBgColor {
  0% {
    background-color: none;
  }
  100% {
    background-color: var(--brand-color);
  }
}
